module.exports = __webpack_public_path__ + "static/media/foooter_code2.3ee4cd4c.png";